import React, { useContext } from 'react'
import { Theme, Link } from '@mui/material'
import { IMAGES_PATH } from 'themes'
import makeStyles from '@mui/styles/makeStyles'
import { Context } from './PayslipsTableFrame-component'
import { useTranslation } from 'react-i18next'
import { useClipboard } from 'use-clipboard-copy'
import Tooltip from '@mui/material/Tooltip'
export interface PayslipStyleProps {
    gridAutoRows: string
}

const accountProfileMenuCopy = IMAGES_PATH(`/copy-icon.svg`)

const useStyles = makeStyles<Theme, PayslipStyleProps>(theme => ({
    splitTableCellView: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gridAutoRows: ({ gridAutoRows }) => gridAutoRows,
        marginTop: '20px',
        gridGap: '0 25px',
        [theme.breakpoints.down('sm')]: {
            display: 'block',
        },
    },
    splitTableCell: {
        paddingBottom: '15px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    walletAddressTableCellView: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        marginTop: '20px',
    },
    walletAddressName: {
        color: `${theme.color.text.secondary}`,
        fontSize: '14px',
    },
    walletAddressHolder: {
        width: '100%',
        display: 'inline-flex',
        alignItems: 'center',
    },
    walletAddressValue: {
        overflow: 'hidden',
        width: '100%',
        whiteSpace: 'nowrap',
        fontWeight: 600,
        [theme.breakpoints.down('sm')]: {
            textOverflow: 'ellipsis',
            whiteSpace: 'initial',
        },
    },
    copyWalletAddressBox: {
        display: 'flex',
        alignItems: 'center',
        '& span': {
            cursor: 'pointer',
            marginLeft: '15px',
            marginTop: '2px',
        },
    },
    copyToClipboardImg: {
        width: '14px',
        height: '16px',
    },
    url: {
        textDecorationColor: `${theme.color.text.main}`,
    },
}))

interface IProps {
    data: any
    height: string
}

export const PayslipTableSplitView: React.FC<IProps> = ({ data, height }) => {
    const { t } = useTranslation()

    const props: PayslipStyleProps = {
        gridAutoRows: `minmax(${height}px, auto)`,
    }

    const { classes } = useContext(Context)
    const localStyles = useStyles(props)

    return (
        <div className={localStyles.splitTableCellView}>
            {!!data?.some(Boolean) &&
                data?.map(
                    ({ name, value }, i) =>
                        !!name &&
                        !!value && (
                            <div key={`${value} + ${name}`} className={localStyles.splitTableCell}>
                                <div className={classes.splitTableCellName}>{t(name)}</div>
                                <div className={classes.splitTableCellValue}>{value}</div>
                            </div>
                        )
                )}
        </div>
    )
}

export const PayslipTableSplitViewForWalletAddresses: React.FC<IProps> = ({ data, height }) => {
    const { t } = useTranslation()
    const clipboard = useClipboard({
        copiedTimeout: 2000,
    })
    const props: PayslipStyleProps = {
        gridAutoRows: `minmax(${height}px, auto)`,
    }
    const localStyles = useStyles(props)

    const handleClipboardClick = (event, value) => {
        event.preventDefault()
        event.stopPropagation()
        clipboard.copy(value)
    }

    return (
        <div className={localStyles.walletAddressTableCellView}>
            {!!data?.some(Boolean) &&
                data?.map(
                    ({ name, value, url }, i) =>
                        !!name &&
                        !!value && (
                            <div key={`${value} + ${name}`} className={localStyles.splitTableCell}>
                                <div className={localStyles.walletAddressName}>{t(name)}</div>
                                <div className={localStyles.walletAddressHolder}>
                                    <div className={localStyles.walletAddressValue}>
                                        {!!url ? (
                                            <Link component="a" href={url} target="_blank" rel="noreferrer" className={localStyles.url} underline="always">
                                                {value}
                                            </Link>
                                        ) : (
                                            value
                                        )}
                                    </div>
                                    {!!value && (
                                        <div data-sta-id="PayslipTableSplitView-component-copyToClipboard" className={localStyles.copyWalletAddressBox}>
                                            <input ref={clipboard.target} value={value} hidden readOnly />
                                            <Tooltip
                                                title={clipboard.copied ? `${t('PayslipTableSplitViewComponent.Copied')}` : `${t('PayslipTableSplitViewComponent.Copy')}`}
                                                placement="top"
                                                data-sta-id="PayslipTableSplitView-component-wallet-address-copy"
                                                arrow={true}
                                                enterDelay={0}
                                                enterTouchDelay={0}
                                            >
                                                <span onClick={e => handleClipboardClick(e, value)}>
                                                    <img className={localStyles.copyToClipboardImg} src={accountProfileMenuCopy} alt={t('PayslipTableSplitViewComponent.CopyWalletAddress')} />
                                                </span>
                                            </Tooltip>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )
                )}
        </div>
    )
}
